import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import _ from "lodash";
import auth_service from "@/services/auth_service";

export const route_ns = `user_access`;

export class UserAccessChangeSchema {
  request_uuid: string | null = null;
  data: UserAccessChangePermissionsSchema;
}

export class UserAccessChangePermissionsSchema {
  permissions: any
}

class UserAccessService {
  public crud = base_ds.getBaseCrud(route_ns);

  public changed: boolean = false;
  public changes: any = {};
  private _permissions: any = {};
  public userAccessDS: any = {};
  public accessHadBeenChanged: boolean = false

  async getUserAccess(user_id: string | null) {
    const payload = {
    }
    const response: AxiosResponse = await this.crud.post(user_id, payload, 100000);
    if (response) {
      return response;
    } else {
      return null;
    }
  }

  async load_cache() {
    if (auth_service.getToken().length === 0) {
      return
    }
    this.loadFromLocalStorage();
    return Promise.resolve(this.loadPermissions())
  }

  async loadPermissions() {
    try {
      const current_id = auth_service.getUserIdFromToken();
      const resp: AxiosResponse['data'] = await request({
        url: `${route_ns}/${current_id}`,
        method: 'get'
      });

      if (resp && resp.data) {
        this._permissions = _.cloneDeep(resp.data);
        localStorage.setItem('_permissions', JSON.stringify(this._permissions));
      }

      const access_ds = await this.getUserAccess(current_id);
      if (access_ds?.data) {
        this.userAccessDS = access_ds.data;
        this.accessHadBeenChanged = true
      }

    } catch (e) {
      console.error(e);
    }
  }

  loadFromLocalStorage() {
    let cache = localStorage.getItem('_permissions');
    if (cache) {
      try {
        this._permissions = JSON.parse(cache);
      } catch (e) {
        this._permissions = {};
      }
    }
  }

  public async save(user_id: string | null, entity: UserAccessChangeSchema) {
    const response: AxiosResponse = await this.crud.post(`${user_id}/save`, entity, 100000);

    if (response && response.data) {
      return { data: true };
    } else {
      return true;
    }
  }

  public async copy(firstUserId: string, secondUserId: string, active_user_node: number | null) {
    const route = route_ns+`/copy`;

    const data = {
      id_user_first: firstUserId,
      id_user_second: secondUserId,
      id_eco_heat_node: active_user_node,
    }
    const response: AxiosResponse["data"] = await request({
        url: route,
        method: "post",
        data: data
      });

    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  }

  // возвращает массив id узлов, для которых разрешено чтение основных страниц
  public checkReading (route: string) {
    let result = [];
    const mainPages = ['ok_hn', 'sale', 'purchase', 'transport_costs', 'transport_income']
    const extraPages = ['settings', 'control', 'blocks']
    const summaryData = ['coast_balance', 'transport', 'balance']
    let page = this.translateRoute(route);
    if(mainPages.includes(page) || extraPages.includes(page)) page = 'main_pages';
    let reading_page = `reading__${page}`
    for(let node in this._permissions) {
      for(let key in this._permissions[node]) {
        if(summaryData.includes(page)) {
          if(!(reading_page in (this._permissions?.[node] || {})) &&
            this._permissions[node][key] !== false) {
              result.push(Number(node));
          }
        }
        if(key === `reading__${page}` && this._permissions[node][key]) {
          result.push(Number(node));
        }
      }
    }
    return result
  }

  public checkEditingConstructor() {
    const result: any = [];
    for(let index in this._permissions) {
      for(let key in this._permissions[index]) {
        if(key === 'editing__group_object_constructor' && this._permissions[index]['editing__group_object_constructor']) {
          result.push(Number(index));
        }
      }
    }
    return result
  }

  public checkReadingConstructor() {
    const result: any = [];
    for(let index in this._permissions) {
      for(let key in this._permissions[index]) {
        if(key === 'reading__group_object_constructor' && this._permissions[index]['reading__group_object_constructor']) {
          result.push(Number(index));
        }
      }
    }
    return result
  }

  public checkReadingSummaryDataRoutes() {
    let result: any = []
    const balance =  Object.values(this.userAccessDS).some((item: any) => item.heat_nodes.some((node: any) => node.permissions.reading__balance === true))
    if(!balance){
      result.push('balance')
    }
    const coastBalance =  Object.values(this.userAccessDS).some((item: any) => item.heat_nodes.some((node: any) => node.permissions.reading__cost_balance === true))
    if(!coastBalance){
      result.push('coast_balance')
    }
    const transport =  Object.values(this.userAccessDS).some((item: any) => item.heat_nodes.some((node: any) => node.permissions.reading__transport === true))
    if(!transport){
      result.push("transport")
    }
    const groupObjectConstructor =  Object.values(this.userAccessDS).some((item: any) => item.heat_nodes.some((node: any) => node.permissions.reading__group_object_constructor === true))
    if(!groupObjectConstructor){
      result.push("group_object_constructor")
    }
    return result
  }

  // проверяет и фильтрует разрешения на редактирование блока ОК/ХН на основе id_eco_heat_node
  public checkEditingBlocks (id_eco_heat_node: number) {
    const result: any = {};
    let expression = `editing__ok_hn__`;
    for(let key in this._permissions[id_eco_heat_node]) {
      if(key.startsWith(expression)) {
        result[key] = this._permissions[id_eco_heat_node][key];
      }
    }
    return result
  }

  // возвращает словарь где для каждого nodeId отфильтрованы права на акцепт
  public checkAccept () {
    const result: any = {};
    let expression = `accept__`;
    Object.keys(this._permissions).forEach(nodeId => {
      if(!result.hasOwnProperty(nodeId)) {
        result[nodeId] = {};
      }
      Object.keys(this._permissions[nodeId]).forEach(key => {
        if(key.startsWith(expression)) {
          result[nodeId][key] = this._permissions[nodeId][key];
        }
      });
    });
    return result
  }

  // проверка доступности редактирования страницы тарифов
  public checkEditingTariff (route: string, id_eco_heat_node: number) {
    let page = this.translateRoute(route);
    let key = `editing__${page}__tariff`;
    if(page === 'tariff') key = `editing__${page}`
    return this._permissions[id_eco_heat_node][key]
  }

  // проверка доступности редактирования страницы контрагентов
  public checkEditingContractor (id_eco_heat_node: number) {
    let key = `editing__contractor`;
    return this._permissions[id_eco_heat_node][key]
  }

  // проверка доступности редактирования объема на странице
  public checkEditingVolume (route: string, id_eco_heat_node: number) {
    let page = this.translateRoute(route);
    let key = `editing__${page}__volume`;
    return this._permissions[id_eco_heat_node][key]
  }

  // проверка доступности добавления/удаления строк для редактирования
  public checkEditingRow (id_eco_heat_node: number) {
    let key = `editing__rows`;
    return this._permissions[id_eco_heat_node][key]
  }

  // преодбразует роут фронта в строку используемую в пермишинах
  public translateRoute(route: string) {
    let result = route
    if(route === 'losses') {
      result = 'ok_hn';
    }
    if(route === 'buy') {
      result = 'purchase';
    }
    if(route === 'contragents') {
      result = 'contractor'
    }
    if(route === 'transport_cost') {
      result = 'transport_costs';
    }
    if(route === 'transport_gain') {
      result = 'transport_income';
    }
    if(route === 'tarifs') {
      result = 'tariff';
    }
    return result;
  }

  // Получить права всех пользователей для рассылки (edit_nodes, read_nodes)
  public async getAllUserAccess() {
    try {
      const resp: AxiosResponse['data'] = await request({
        url: `${route_ns}/for_all_user`,
        method: 'get'
      });
      if (resp && resp.data) {
        return resp.data;
      } else {
        return null;
      }
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  public async multy_copy(from_user_id: string, to_user_ids: string[], facility_id: number): Promise<boolean> {
    const route = route_ns + `/multy_copy`;

    const data = {
      from_user_id: from_user_id,
      to_user_ids: to_user_ids,
      facility_id: facility_id
    };

    console.log("Отправка данных:", data);

    try {
      const response: AxiosResponse = await request({
        url: route,
        method: "post",
        data: data,
      });

      console.log("Ответ от сервера:", response.data);

      if (response && response.data === true) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Ошибка запроса:", error);
      return false;
    }
  }
}

export default new UserAccessService();
